var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92417 8.18182H7.40765L5.96111 3.30183C5.8989 3.08917 5.82113 2.78231 5.7278 2.38123C5.63448 1.98016 5.57809 1.70128 5.55865 1.54458C5.51977 1.78336 5.45658 2.09302 5.36909 2.47357C5.28159 2.85412 5.20868 3.13767 5.15036 3.32421L3.73882 8.18182H2.22229L1.1199 4.08531L0 0H1.4232L2.64226 4.76806C2.83279 5.5329 2.96889 6.20818 3.05055 6.79393C3.09332 6.4768 3.15749 6.12238 3.24303 5.73063C3.32858 5.33889 3.40635 5.02176 3.47635 4.77926L4.86455 0H6.24692L7.67012 4.80164C7.80622 5.24562 7.9501 5.90971 8.10175 6.79393C8.16008 6.26041 8.30006 5.5814 8.52171 4.75687L9.73493 0H11.1465L8.92417 8.18182ZM18 2.47357C18 3.32795 17.7084 3.98271 17.1251 4.43788C16.5418 4.89305 15.7116 5.12063 14.6345 5.12063H13.7479V8.18182H12.3539V0H14.8095C15.8749 0 16.673 0.208927 17.2038 0.626788C17.7346 1.04465 18 1.66024 18 2.47357ZM13.7479 3.99577H14.4887C15.2042 3.99577 15.7291 3.87638 16.0635 3.63761C16.3979 3.39883 16.5651 3.02575 16.5651 2.51834C16.5651 2.04825 16.4154 1.69755 16.116 1.46624C15.8166 1.23492 15.35 1.11926 14.7161 1.11926H13.7479V3.99577Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/WP.70c804dcccfce6873d0985670a457e8b.svg";
export { ForwardRef as ReactComponent };